import { environmentSvc } from './environment.service';
import { ErrorCode } from './errors/error-codes';

type LogType = 'log' | 'debug' | 'warn' | 'error';

class LoggingService {
  private logEnabled: boolean = process?.env?.LOG === 'f';

  private get logToConsole() {
    return !this.logEnabled;
  }

  public log(message?: any, ...optionalParams: unknown[]) {
    if (this.logToConsole) {
      // eslint-disable-next-line no-console
      console.log(message, ...optionalParams);
    }
  }

  public warn(message?: any, ...optionalParams: unknown[]) {
    if (this.logToConsole) {
      // eslint-disable-next-line no-console
      console.warn(message, ...optionalParams);
    }
    this.sendBeacon('warn', message, '', ...optionalParams);
  }

  public error(errorCode: ErrorCode, message?: any, ...optionalParams: unknown[]) {
    const extendedMessage = this.extendMessage(errorCode, message, optionalParams);
    if (this.logToConsole) {
      // eslint-disable-next-line no-console
      console.error(extendedMessage, ...optionalParams);
    }
    this.sendBeacon('error', extendedMessage, Error('remoteStack').stack, ...optionalParams);
  }

  private sendBeacon(type: LogType, message?: any, stack?: string, ...optionalParam: unknown[]) {
    if (environmentSvc.isLocalhost || !('sendBeacon' in navigator)) {
      return;
    }
    navigator.sendBeacon(
      environmentSvc.assetsHost + '/api/log',
      JSON.stringify({
        type,
        origin: window.location.href,
        message,
        data: optionalParam,
        stack,
      })
    );
  }

  private extendMessage = (errorCode: ErrorCode, message: string, data: any[] = []) =>
    `UI${errorCode} ${message} @ ${window.location.href} | ${data.map((d) => '' + d).join(' | ')}`;
}

export const logger = new LoggingService();
